<template>
  <div id="ranking-board">
    <div class="ranking-board-title">任务上报排行榜</div>
    <dv-scroll-ranking-board :config="config" />
  </div>
</template>

<script>
export default {
  name: 'RankingBoard',
  data() {
    return {
      config: {
        data: [
          {
            name: '广西桂平3号18公分',
            value: 55
          },
          {
            name: '遂宁130PM25型',
            value: 120
          },
          {
            name: '麻阳26公分',
            value: 78
          },
          {
            name: '广西桂平2号14公分',
            value: 66
          },
          {
            name: '麻阳30公分',
            value: 80
          },
          {
            name: '民乐120JH70型',
            value: 45
          },
          {
            name: '上饶30000型',
            value: 29
          },
          {
            name: '三合20型',
            value: 29
          },
          {
            name: '忻城35号42公分',
            value: 29
          }
        ],
        rowNum: 9
      }
    }
  }
}
</script>

<style lang="less">
#ranking-board {
  width: 20%;
  box-shadow: 0 0 3px blue;
  display: flex;
  flex-direction: column;
  background-color: rgba(6, 30, 93, 0.5);
  border-top: 2px solid rgba(1, 153, 209, 0.5);
  box-sizing: border-box;
  padding: 0px 30px;

  .ranking-board-title {
    font-weight: bold;
    height: 50px;
    display: flex;
    align-items: center;
    font-size: 20px;
  }

  .dv-scroll-ranking-board {
    flex: 1;
  }
}
</style>
